import { render, staticRenderFns } from "./DotInspect.vue?vue&type=template&id=68f2c602&"
import script from "./DotInspect.vue?vue&type=script&lang=js&"
export * from "./DotInspect.vue?vue&type=script&lang=js&"
import style0 from "./DotInspect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
